import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'antd';
import styled from 'styled-components';
import { space, width } from 'styled-system';

const StyledInputNumber = styled(InputNumber)`
  ${space}
  ${width}
  width: 100% !important;
`;

export function InputNumberControl({ settings, name, onChange, onBlur, ...props }) {
  return (
    <StyledInputNumber
      width={1}
      name={name}
      onChange={value => onChange({ target: { name, value } })}
      onBlur={value => onBlur({ target: { name, value } })}
      {...settings}
      {...props}
    />
  );
}

InputNumberControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
